// Copyright (c) Docugami, Inc. All rights reserved.
export interface UrlHashParametersState {
    hash: string;
    query: string;
    dictionary: { [key: string]: string }
}

export const SET_URL_HASH_PARAMETERS_STATE = "SET_URL_HASH_PARAMETERS_STATE";

interface UpdateUrlHashParametersState {
    type: typeof SET_URL_HASH_PARAMETERS_STATE;
    payload: UrlHashParametersState;
}

export type UrlHashParametersActionTypes = 
    UpdateUrlHashParametersState;